import { FC } from 'react';
import { Electro } from '../tree/node/icons-tree/electro';
import { ColdWater } from '../tree/node/icons-tree/cold_water';
import { HotWater } from '../tree/node/icons-tree/hot_water';
import { Cool } from '../tree/node/icons-tree/cool';
import { Gaz } from '../tree/node/icons-tree/gaz';
import { Warm } from '../tree/node/icons-tree/warm';
import { WaterTap } from '../tree/node/icons-tree/water_tap';
import { Arkus } from '../tree/node/icons-tree/arkus';
import { Arrows } from '../tree/node/icons-tree/arrows';
import { Asq } from '../tree/node/icons-tree/asq';
import { Axes } from '../tree/node/icons-tree/axex';
import { BlueMan } from '../tree/node/icons-tree/blue_man';
import { C2000 } from '../tree/node/icons-tree/c2000';
import { Cmk } from '../tree/node/icons-tree/cmk';
import { ComPort } from '../tree/node/icons-tree/com_port';
import { Connector } from '../tree/node/icons-tree/connector';
import { DateTime } from '../tree/node/icons-tree/datetime';
import { Dz } from '../tree/node/icons-tree/dz';
import { EiasJkhMo } from '../tree/node/icons-tree/EiasJkhMo';
import { Ethernet } from '../tree/node/icons-tree/ethernet';
import { GisJkh } from '../tree/node/icons-tree/gis_jkh';
import { GreenMan } from '../tree/node/icons-tree/green_man';
import { Group } from '../tree/node/icons-tree/group';
import { GroupHouse } from '../tree/node/icons-tree/group_house';
import { House } from '../tree/node/icons-tree/house';
import { Internet } from '../tree/node/icons-tree/internet';
import { MultyUser } from '../tree/node/icons-tree/multy_user';
import { OdinAss } from '../tree/node/icons-tree/OdinAss';
import { OpcServer } from '../tree/node/icons-tree/OpcServer';
import { Palette } from '../tree/node/icons-tree/palette';
import { Printers } from '../tree/node/icons-tree/printers';
import { ProgramBehaviour } from '../tree/node/icons-tree/program_behaviour';
import { Receipts } from '../tree/node/icons-tree/receipts';
import { RedMan } from '../tree/node/icons-tree/red_man';
import { RedGreenMan } from '../tree/node/icons-tree/redgreen_man';
import { Registrator } from '../tree/node/icons-tree/registrator';
import { Rip } from '../tree/node/icons-tree/rip';
import { RootBalance } from '../tree/node/icons-tree/root_balance';
import { RootDevice } from '../tree/node/icons-tree/RootDevice';
import { RootUser } from '../tree/node/icons-tree/RootUser';
import { Router } from '../tree/node/icons-tree/router';
import { SmtpServer } from '../tree/node/icons-tree/smtp_server';
import { SystemGorod } from '../tree/node/icons-tree/system_gorod';
import { SystemGroup } from '../tree/node/icons-tree/system_group';
import { Telegram } from '../tree/node/icons-tree/telegram';
import { Thunder } from '../tree/node/icons-tree/thunder';
import { Uk16 } from '../tree/node/icons-tree/uk16';
import { User } from '../tree/node/icons-tree/user';
import { ViewedColsProps } from '../tree/node/icons-tree/viewed_cols_props';
import { Virtual } from '../tree/node/icons-tree/Virtual';
import { Vt } from '../tree/node/icons-tree/vt';
import { WebServer } from '../tree/node/icons-tree/web_server';
import { WindowTariffs } from '../tree/node/icons-tree/WindowTariffs';
import { Wireless } from '../tree/node/icons-tree/wireless';
import { Xml80020 } from '../tree/node/icons-tree/xml80020';
import { Performance } from '../tree/node/icons-tree/performance';
import { Gear } from '../tree/node/icons-tree/gear';
import { DeviceSvg } from './sidebar/deviceSvg';
import { BalanceSvg } from './sidebar/balanceSvg';
import { ManualSvg } from './sidebar/manualSvg';
import { ConsumptionSvg } from './sidebar/consumptionSvg';
import { VtSvg } from './sidebar/vtSvg';
import { ReportSvg } from './sidebar/reportSvg';
import { ExportSvg } from './sidebar/exportSvg';
import { PlannerSvg } from './sidebar/plannerSvg';
import { MapSvg } from './sidebar/mapSvg';
import { OperatorSvg } from './sidebar/operatorSvg';
import { LogSvg } from './sidebar/logSvg';
import { SettingSvg } from './sidebar/settingSvg';
import { HelpSvg } from './sidebar/helpSvg';
import { GraphSvg } from './sidebar/graphSvg';
import { TPlannerEvent } from '../tree/node/icons-tree/TPlannerEvent';

export const ResursIcon: FC<{ icon?: string }> = ({ icon }) => {
  switch (icon) {
    case 'arkus':
      return <Arkus />;
    case 'arrows':
      return <Arrows />;
    case 'asq':
      return <Asq />;
    case 'axes':
      return <Axes />;
    case 'blue_man':
      return <BlueMan />;
    case 'bolid_counters':
      return <ColdWater />;
    case 'c2000':
      return <C2000 />;
    case 'cmk':
      return <Cmk />;
    case 'cold_water':
      return <ColdWater />;
    case 'com_port':
      return <ComPort />;
    case 'connector':
      return <Connector />;
    case 'cool':
      return <Cool />;
    case 'date_and_time':
      return <DateTime />;
    case 'dz':
      return <Dz />;
    case 'eias_jkh_mo':
      return <EiasJkhMo />;
    case 'electro':
      return <Electro />;
    case 'ethernet':
      return <Ethernet />;
    case 'gaz':
      return <Gaz />;
    case 'gis_jkh':
      return <GisJkh />;
    case 'green_man':
      return <GreenMan />;
    case 'group':
      return <Group />;
    case 'group_house':
      return <GroupHouse />;
    case 'hot_water':
      return <HotWater />;
    case 'house':
      return <House />;
    case 'r_overall':
    case 'r_proxy_msg':
    case 'r_asq':
    case 'integration':
      return <Gear />;
    case 'internet':
      return <Internet />;
    case 'multy_user':
      return <MultyUser />;
    case 'odin_ass':
      return <OdinAss />;
    case 'opc_server':
      return <OpcServer />;
    case 'palette':
      return <Palette />;
    case 'perfomance':
      return <Performance />;
    case 'printers':
      return <Printers />;
    case 'program_behaviour':
      return <ProgramBehaviour />;
    case 'receipts':
      return <Receipts />;
    case 'red_man':
      return <RedMan />;
    case 'redgreen_man':
      return <RedGreenMan />;
    case 'registrator':
      return <Registrator />;
    case 'rip':
      return <Rip />;
    case 'http_proxy':
      return <WebServer />;
    case 'RootBalance':
      return <RootBalance />;
    case 'RootHome':
      return <GroupHouse />;
    case 'RootOperator':
      return <RedGreenMan />;
    case 'RootDevice':
      return <RootDevice />;
    case 'RootUser':
      return <RootUser />;
    case 'router':
      return <Router />;
    case 'smtp_server':
      return <SmtpServer />;
    case 'system_gorod':
      return <SystemGorod />;
    case 'system_group':
      return <SystemGroup />;
    case 'Telegram':
      return <Telegram />;
    case 'thunder':
      return <Thunder />;
    case 'uk16':
      return <Uk16 />;
    case 'user':
      return <User />;
    case 'viewed_cols_props':
      return <ViewedColsProps />;
    case 'virtual':
      return <Virtual />;
    case 'vt':
      return <Vt />;
    case 'warm':
      return <Warm />;
    case 'water_tap':
      return <WaterTap />;
    case 'web_server':
      return <WebServer />;
    case 'window_tariffs':
      return <WindowTariffs />;
    case 'wireless':
      return <Wireless />;
    case 'xml80020':
      return <Xml80020 />;
    case 'TPlannerEvent':
      return <TPlannerEvent />;
    case 'sidebar_device':
      return <DeviceSvg />;
    case 'sidebar_balance':
      return <BalanceSvg />;
    case 'sidebar_manual':
      return <ManualSvg />;
    case 'sidebar_consumption':
      return <ConsumptionSvg />;
    case 'sidebar_vt':
      return <VtSvg />;
    case 'sidebar_report':
      return <ReportSvg />;
    case 'sidebar_export':
      return <ExportSvg />;
    case 'sidebar_planner':
      return <PlannerSvg />;
    case 'sidebar_map':
      return <MapSvg />;
    case 'sidebar_operator':
      return <OperatorSvg />;
    case 'sidebar_log':
      return <LogSvg />;
    case 'sidebar_settings':
      return <SettingSvg />;
    case 'sidebar_help':
      return <HelpSvg />;
    case 'sidebar_graph':
      return <GraphSvg />;
    default:
      return <></>;
  }
};
